// extracted by mini-css-extract-plugin
export var caretAnchor = "_w1-0";
export var dropdownContent = "_w1-1";